"use client";
import { useQuery } from "@tanstack/react-query";
import { getCustomerApi } from "@/services";
import { transform } from "utils";
import { GlobalContext } from "@/context";
import { useContext } from "react";
import { useAccount } from "wagmi";
import { message } from '@/components';



const customerApi = getCustomerApi()
export const useSeasonConfig = () => {
  const { loggingIn } = useContext(GlobalContext);
  const { address } = useAccount();
  const { data: seasonConfig, isFetching: isConfigLoading } = useQuery({
    queryKey: ["GET_SEASON_CONFIG", loggingIn, address],
    enabled: !!loggingIn,
    async queryFn() {
      const {data, error} = await customerApi.seasons.seasons();
      if (error) {
        message({
          content:'Oops...Something went wrong. Please try again.',
          className:'message-error'
        })
      }
      return transform(data?.obj || []) || [];
    },
    select(data) {
      // @ts-ignore
      const config = data && data.length > 1 ? data?.sort((a: any, b: any) => b.id - a.id) : data;
      const currentSeason = config?.find((item:any) => item.current);
      return transform(currentSeason);
    },
  });

  return {
    seasonConfig,
    isConfigLoading,
  }
}